import React, { useState, useEffect, useContext } from 'react';
import "../Notification/Information.css"
import '../Notification/Succses.css';
import { Context } from "../../../index";
import { observer } from "mobx-react-lite";
import Sound_play from '../../../Utils/sound_play';
import { error_sound } from '../../../Utils/sounds';

const ErrorComponent = ({ message, onClose, state, key, index, disappear }) => {
    const { store } = useContext(Context)
    let r_message = ""
    for (const mess_data of message.split("|")) {
        r_message += store.dataLang[mess_data] ? store.dataLang[mess_data] : mess_data
    }

    const [visible, setVisible] = useState(true);
    let timer1, timer2;

    useEffect(() => {
        Sound_play(error_sound, store.sound)
        const toast = document.querySelector(`#index_${index}`);
        const progress = document.querySelector(`#index_${index}.progress`);

        if (!disappear) {
            if (!timer1) {
                timer1 = setTimeout(() => {
                    toast.classList.remove("active");
                    if (!toast.classList.contains("disable")) {
                        toast.classList.add("disable")


                    }

                }, 2000);
            }


            timer2 = setTimeout(() => {
                // toast.remove()
                setVisible(false)
                onClose()
            }, 3000);
        }



        // closeIcon.addEventListener("click", () => {
        //
        //
        //
        //     clearTimeout(timer1);
        //     clearTimeout(timer2);
        // });

    }, [])

    function handleClickClose() {

        const toast = document.querySelector(`#index_${index}`);
        const progress = document.querySelector(`#index_${index}.progress`);
        toast.classList.remove("active");
        toast.classList.add("disable")

        clearTimeout(timer1)
        clearTimeout(timer2)

        setTimeout(() => {

            setVisible(false)
            onClose()
        }, 800);
    }

    return (
        <>
            {visible && (


                <div className="toast active" id={`index_${index}`}>

                    <div className="toast-content">
                        <i className="fas fa-regular fa-xmark check red"></i>

                        <div className="message text text-1" dangerouslySetInnerHTML={{ __html: r_message }}>

                        </div>
                    </div>

                    <i className="fa-solid fa-xmark close hover_close" onClick={handleClickClose}></i>
                    <div className="progress red active"></div>
                </div>


            )}
        </>
    );
};

export default observer(ErrorComponent);